import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { registerUser, updateUserData2 } from '../../controllers/user.controller'
import {toast} from "react-hot-toast";

function Register() {
  

  const [formPage, setFormPage] = useState(0)
  const [registerData, setRegisterData] = useState({email:"", password:"", name:"", lastName:"",  DNI:"", carrera:"", legajo:"",añoIngreso:"", materiasAprob:"", celular:"", zona:""})

  function nextpage(){
    setFormPage(formPage+1)
  }

  function prevpage(){
    setFormPage(formPage-1)
  }

  const navigate =useNavigate()
  function goTo(place){
    navigate(place)
  }

  function createNewProfile(mood) {
    if(mood===1){
      registerUser(registerData.email, registerData.password).
      then(
        (data) => {
          //convertí en await para que espere el resultado y use un array
          if(data.length === 0){
            nextpage()

          }
        }
      ).catch(
        e => toast.error(e.message)
      )
      
    }else{
      updateUserData2(
        registerData.email,
        registerData.name,
        registerData.lastName,
        registerData.email,
        registerData.DNI, 
        registerData.celular,
        registerData.zona,
        registerData.carrera,
        registerData.legajo, 
        registerData.añoIngreso, 
        registerData.materiasAprob
       ).then(
        data => goTo("/")
      ).catch(
        e => console.log(e)
      )    
    }
    
  }

  return (
    <div className='fullContainer bg-white d-flex flex-column align-items-center justify-content-center'>
        <div className="rounded-5 py-4 bg-white border border-4 border-success d-flex flex-column gap-2 mx-2">
            <h1 className="dark text-center mb-4">Registrarme</h1>

            { formPage===0 && <div className="d-flex flex-column gap-3 px-3">
                  <input value={registerData.email} onChange={e => setRegisterData({...registerData,email:e.target.value})} className="input" type="email" placeholder='Correo electrónico'/>
                  <input value={registerData.password} onChange={e => setRegisterData({...registerData,password:e.target.value})} className="input" type="text" placeholder='Contraseña'/>  
                  {registerData.password.length>5 && registerData.email.length>9 && registerData.email.includes("@")?
                  <button className="yellowBtn" onClick={()=>createNewProfile(1)} >Registrarme</button>
                  :
                  <button className="btn btn-lg btn-success regularText" disabled>Complete los datos</button>
                  }
                  <p className="darkMediun mt-4 click" onClick={() => goTo("/login")}>Ya tengo un usuario, deseo Ingresar</p>

              </div> 
            }

            { formPage===1 && <div className="d-flex flex-column gap-3 px-3">
                  <input value={registerData.name} onChange={e => setRegisterData({...registerData,name:e.target.value})} className="input" type="text" placeholder='Nombres'/>
                  <input value={registerData.lastName} onChange={e => setRegisterData({...registerData,lastName:e.target.value})} className="input" type="text" placeholder='Apellidos'/>
                  <input value={registerData.DNI} onChange={e => setRegisterData({...registerData,DNI:e.target.value})} className="input" type="number" placeholder='DNI'/>  
                  {registerData.name.length>3 && registerData.lastName.length>3&& registerData.DNI.length>6?
                  <button className="yellowBtn" onClick={nextpage} >Siguiente</button>
                  :
                  <button className="btn btn-lg btn-success regularText" disabled>Complete los datos</button>
                  }

              </div> 
            }

            { formPage===2 && <div className="d-flex flex-column gap-2 px-3">

               <select class="form-select mb-3" aria-label=".form-select-lg example" defaultValue='default' onChange={e => setRegisterData({...registerData,carrera:e.target.value})}>
                  <option value="default" disabled="disabled">Carrera</option>
                  <option value="Tec. Fitosanitarista">Tec. Fitosanitarista</option>
                  <option value="Tec. en Aserraderos">Tec. en Aserraderos</option>
                  <option value="Tec. en Viveros">Tec. en Viveros</option>
                  <option value="Ing. Forestal">Ing. Forestal</option>
                  <option value="Ing. en Industria Forestal">Ing. en Industria Forestal</option>
                  <option value="Lic. en Ecología y Conservación del Ambiente">Lic. en Ecología y Conservación del Ambiente</option>
                  <option value="Lic. en Enseñanzas de la Biología">Lic. en Enseñanzas de la Biología</option>
                </select>

                <input value={registerData.legajo} onChange={e => setRegisterData({...registerData,legajo:e.target.value})} className="input" type="text" placeholder='Legajo'/>
                <input value={registerData.añoIngreso} onChange={e => setRegisterData({...registerData,añoIngreso:e.target.value})} className="input" type="text" placeholder='Año de ingreso'/>
                <input value={registerData.materiasAprob} onChange={e => setRegisterData({...registerData,materiasAprob:e.target.value})} className="input" type="number" placeholder='Nro de materias aprobadas'/>
                {registerData.carrera!=="default" && registerData.legajo.length>3 && registerData.añoIngreso.length>3 ? 
                  <div className="text-center d-flex align-items-center justify-content-center flex-wrap gap-2">

                      <button className="btn btn-lg btn-success regularText col-12" onClick={prevpage}>Anterior</button>
                      <button className="yellowBtn col-12" onClick={nextpage}>Siguiente</button>

                  </div>
                :
                  <div className="text-center">
                        <button className="btn btn-lg btn-success regularText" disabled>Completar...</button>
                  </div>
                }

              </div> 
            }

            { formPage===3 && <div className="d-flex flex-column gap-2 px-3">
                 <input value={registerData.celular} onChange={e => setRegisterData({...registerData,celular:e.target.value})} className="input" type="text" placeholder='Número de celular'/>  
                 <select class="form-select mb-3" aria-label=".form-select-lg example" defaultValue='default' onChange={e => setRegisterData({...registerData,zona:e.target.value})}>
                  <option value="default" disabled="disabled">Zona</option>
                  <option value="Capital">Santiago Capital</option>
                  <option value="La banda">La banda</option>
                  <option value="Interior de Santiago">Interior de Santiago</option>
                  <option value="Otro">Otro</option>
                </select> 

                {registerData.celular.length>7 && registerData.zona!=="default"  ? 
                  <div className="text-center d-flex align-items-center justify-content-center gap-2 flex-wrap">
                        <button className="btn btn-lg btn-success regularText col-12" onClick={prevpage}>Anterior</button>
                        <button className="yellowBtn col-12" onClick={() => createNewProfile(2)}>Terminar</button>
                  </div>
                :
                  <div className="text-center">
                        <button className="btn btn-lg btn-success regularText" disabled>Completar...</button>
                  </div>
                } 
  
              </div> 
            }

        </div>
    </div>
  )
}

export default Register